import { render, staticRenderFns } from "./physioData.vue?vue&type=template&id=5171f3fa&scoped=true"
import script from "./physioData.vue?vue&type=script&lang=js"
export * from "./physioData.vue?vue&type=script&lang=js"
import style0 from "./physioData.vue?vue&type=style&index=0&id=5171f3fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5171f3fa",
  null
  
)

export default component.exports